<div class="col-12">

    <div class="menu"  *ngIf="title">
        <span class="menu-heading">{{title}}</span>
        <span class="close" (click)="close()">X</span>
    </div>
    
    <div class="row console p-0 m-0">
        <div class="col-8 left-col border" style="padding-top: 1rem!important;">
            <span class="console-heading">UPLOAD FILE</span>
            <div class="upload">
                <!-- <form>
                    <image-uploader (files)="filesDropped($event)" [activeColor]="'orangered'" [baseColor]="'Navy'"
                        class="img-uploader"></image-uploader>
                </form> -->
                <div class="dd-box">
                    <label
                      class="uploader"
                      ondragover="return false;"
                      [class.loaded]="loaded"
                      [style.outlineColor]="dragging ? activeColor : baseColor"
                      (dragenter)="handleDragEnter()"
                      (dragleave)="handleDragLeave()"
                      (drop)="handleDrop($event)"
                    >
                      <!-- class="icon icon-upload bi bi-upload fs-1" -->
                      <img
                        [hidden]="imageLoaded"
                        [src]="baseHref + '/assets/images/icon-download.svg'"
                        [style.color]="
                          dragging
                            ? imageSrc.length > 0
                              ? overlayColor
                              : activeColor
                            : imageSrc.length > 0
                              ? overlayColor
                              : baseColor
                        "
                      />
                      <br />
              
                      <img alt="" [src]="imageSrc" (load)="handleImageLoad()" [class.loaded]="imageLoaded" />
                    </label>
                    <span class="item">Drag and Drop</span><br />
                    <span class="item">File Here</span>
                  </div>
                  <input (change)="handleInputChange($event)" type="file" id="actual-btn" hidden />
              
                  <!-- our custom upload button -->
                  <label class="item">Or</label><br />
                  <div class="choose-file-box mt-1">
                    <label for="actual-btn" class="outline-btn info-lbl">Choose File</label>
              
                    <!-- name of file chosen -->
                    <span id="file-chosen" class="item ps-2">No file chosen</span>
                    <label style="margin-top: 11px;" title={{savingFileMessage}} > 
                      {{savingFileMessage.length>60?savingFileMessage.substring(0,45)+'...':savingFileMessage}}
                    </label>
                  </div>
            </div>
        </div>

        <div class="col-4 border pt-5">
            <label class="item-right" style="margin-bottom: 1.5rem;">Requirements</label>
            <label class="item-right sub">Allowed File Types</label>
            <ul class="list-styled item-list mt-2 ps-4">
              <li *ngFor="let item of allowedFileTypes"><strong>{{ item.label}} ({{item.ext}})</strong></li>
            </ul>
            <label class="item-right sub">Maximum File Size</label>
            <ul class="list-styled item-list mt-2 ps-4" style="margin-bottom: 1.5rem;">
                <li>{{maxFileSize}}</li>
            </ul>
        </div>
    </div>

    <div class="menu-bottom text-center">
        <button class="main-btn large" (click)="saveFile()">Save</button>
        <button class="outline-btn large ms-2" (click)="close()">Cancel</button>
    </div>

</div>